import $P from 'plugins/kapida/platformConfigs/integrationMaps/signin';
import { objectSelector } from 'theme/utils';

class SignInSmsVerficiationRejected {
  constructor(data) {
    const { smsCode } = data;

    this.smsCode = smsCode;
  }
}

export const signInSmsVerficiationRejectedMapper = (error) => {
  return new SignInSmsVerficiationRejected({
    smsCode: objectSelector(error, $P.ERROR_MESSAGES.SMS_CODE),
  });
};



// WEBPACK FOOTER //
// ./src/models/kapidaModels/signInSmsVerificationRejected.js